

document.addEventListener("DOMContentLoaded", function () {
  const message = document.querySelector(".form-success");

  if (message) {
    let timeLeft = 10;

    const counter = document.createElement("span");
    counter.textContent = ` (${timeLeft})`;
    message.appendChild(counter);

    const timer = setInterval(function () {
      timeLeft--;
      counter.textContent = ` (${timeLeft})`;

      if (timeLeft <= 0) {
        clearInterval(timer);
        message.style.display = "none";
      }
    }, 1000);
  }
});

function toggleMobileMenu() {

  const menu = document.getElementById("mobileMenu");
  const overlay = document.getElementById("mobileOverlay");

  menu.classList.toggle("active");
  overlay.classList.toggle("active");

}


document.addEventListener("click", function(event) {
  const menu = document.getElementById("mobileMenu");
  const btn = document.querySelector(".mobile-menu-btn");

  if (!menu.contains(event.target) && !btn.contains(event.target)) {
    menu.classList.remove("active");
  }
});

document.addEventListener("click", function(event) {
  const menu = document.getElementById("mobileMenu");
  const btn = document.querySelector(".mobile-menu-btn");

  if (!menu.contains(event.target) && !btn.contains(event.target)) {
    menu.classList.remove("active");
  }
});


  const nameInput = document.getElementById('about-name');
  const emailInput = document.getElementById('about-email');
  const phoneInput = document.getElementById('about-phone');
  const messageInput = document.getElementById('about-message');
  const submitBtn = document.getElementById('submitBtn');

  const errors = {
    name: document.getElementById('error-name'),
    email: document.getElementById('error-email'),
    phone: document.getElementById('error-phone'),
    message: document.getElementById('error-message')
  };

const emailRegex = /^[^\s@]+@[^\s@\.]+\.[^\s@\.]+$/;

  nameInput.addEventListener('input', () => {
    nameInput.value = nameInput.value.replace(/[^a-zA-Z\s]/g, '');

    if (!nameInput.value.trim()) {
      showError(nameInput, errors.name, 'Name is required');
    } else {
      clearError(nameInput, errors.name);
    }
    toggleSubmit();
  });

  phoneInput.addEventListener('input', () => {
    phoneInput.value = phoneInput.value.replace(/\D/g, '');

    if (phoneInput.value.length < 10) {
      showError(phoneInput, errors.phone, 'Enter a valid phone number');
    } else {
      clearError(phoneInput, errors.phone);
    }
    toggleSubmit();
  });

  // emailInput.addEventListener('input', () => {
  //   if (!emailRegex.test(emailInput.value)) {
  //     showError(emailInput, errors.email, 'Enter a valid email address');
  //   } else {
  //     clearError(emailInput, errors.email);
  //   }
  //   toggleSubmit();
  // });

  emailInput.addEventListener('input', () => {

  const email = emailInput.value;

  // count @
  const atCount = (email.match(/@/g) || []).length;

  // only one dot after @
  const domainPart = email.split('@')[1] || '';
  const dotCount = (domainPart.match(/\./g) || []).length;

  if (!emailRegex.test(email) || atCount !== 1 || dotCount !== 1) {
    showError(emailInput, errors.email, 'Enter a valid email address');
  } else {
    clearError(emailInput, errors.email);
  }

  toggleSubmit();
});

  messageInput.addEventListener('input', () => {
    if (!messageInput.value.trim()) {
      showError(messageInput, errors.message, 'Message is required');
    } else {
      clearError(messageInput, errors.message);
    }
    toggleSubmit();
  });

  /* Helpers */
  function showError(input, errorEl, msg) {
    errorEl.textContent = msg;
    input.classList.add('error');
  }

  function clearError(input, errorEl) {
    errorEl.textContent = '';
    input.classList.remove('error');
  }
  function toggleSubmit() {
    const hasError = document.querySelectorAll('.error-msg')
      ? [...document.querySelectorAll('.error-msg')].some(e => e.textContent !== '')
      : false;

      const allFilled =
        nameInput.value.trim() !== '' &&
        emailInput.value.trim() !== '' &&
        phoneInput.value.trim() !== '' &&
        messageInput.value.trim() !== '';

      submitBtn.disabled = hasError || !allFilled;
  }

  /* Block submit if disabled */
  document.getElementById('contactForm').addEventListener('submit', e => {
    if (submitBtn.disabled) {
      e.preventDefault();
    }
  });
